var React = require('react');

function Shared (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"share","transform":"translate(-800 -440)"},[React.createElement("rect",{"id":"nền_24x24","data-name":"nền 24x24","width":"24","height":"24","transform":"translate(800 440)","fill":"#fff","key":0}),React.createElement("path",{"id":"share-2","data-name":"share","d":"M24.325,13.748,16.977,6.875a.376.376,0,0,0-.292-.125c-.229.01-.521.172-.521.417v3.447a.223.223,0,0,1-.187.214C8.672,11.947,5.594,17.414,4.506,23.09c-.042.224.26.432.4.255,2.666-3.359,5.91-5.551,11.04-5.593a.258.258,0,0,1,.219.25v3.385a.447.447,0,0,0,.755.276l7.4-6.993a.575.575,0,0,0,.182-.437A.7.7,0,0,0,24.325,13.748Z","transform":"translate(797.998 436.751)","fill":"none","stroke":"#686868","strokeWidth":"1","key":1})]));
}

Shared.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Shared;

Shared.default = Shared;
